import React from "react";
import { Grid, Popup, Icon, Input } from "semantic-ui-react";
import { HostRoute } from "../../../types/hostRoute";
import useHostRoutesChange from "./useHostRoutesChange";

type HostRoutesProps = {
  hostRoutes: HostRoute[];
  onHostRoutesChange: (data: HostRoute[]) => void;
};

const HostRoutes = ({ hostRoutes, onHostRoutesChange }: HostRoutesProps) => {
  const { onDestinationChange, onNextHopChange, onAddRow, onDeleteRow } =
    useHostRoutesChange(hostRoutes, onHostRoutesChange);

  return (
    <>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-20 margin-bottom-20"
      >
        <h5>
          Start
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left"
              />
            }
          >
            Format example : 192.168.0.0/24
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-20 margin-bottom-20"
      >
        <h5>
          Nexthop
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left"
              />
            }
          >
            Format example : 192.168.0.1
          </Popup>
        </h5>
      </Grid.Column>
      {hostRoutes.map((pool, i) => (
        <React.Fragment key={i}>
          <Grid.Column textAlign="left" width={8} className="">
            <Input
              key={i}
              className="select-box full width-100p margin-bottom-20"
              value={pool.destination}
              name="destination"
              data-index={i}
              onChange={onDestinationChange}
            />
          </Grid.Column>

          <Grid.Column textAlign="left" width={8} className="">
            <Input
              key={i}
              className="flex select-box full width-100p margin-bottom-20"
            >
              <input
                value={pool.nexthop}
                className="flex-1"
                data-index={i}
                onChange={onNextHopChange}
              />
              {i === 0 ? (
                <button
                  onClick={onAddRow}
                  className="button button--over-input"
                >
                  <Icon name="plus" />
                </button>
              ) : (
                <button
                  data-index={i}
                  onClick={onDeleteRow}
                  className="button button--over-input"
                >
                  <Icon name="trash" />
                </button>
              )}
            </Input>
          </Grid.Column>
        </React.Fragment>
      ))}
    </>
  );
};

export default HostRoutes;
